<div class="container gray s-header" *yatVar="title$ | async as title">
  <h1><transloco id="735e310c-5b6d-46af-ac84-7d2cc3d722d3" *ngIf="title" [key]="title.key" [params]="title.params" [scope]="title.scope"></transloco></h1>
  <span class="helper-icon" *ngIf="titleIcon$ | async as titleIcon">
    <yat-icon id="160f96b0-2d67-43c2-b10b-ba0f9ba16879" [name]="titleIcon" [class]="titleIconClass$ | async"></yat-icon>
  </span>
</div>
